import { jsx as _jsx } from "react/jsx-runtime";
import { styled, Typography } from '@mui/material';
const getSize = (variant) => variant === 'section' ? 'h5' : 'subtitle1';
export const Title = ({ children, }) => _jsx(Typography, { variant: 'h4', children: children });
export const SectionTitle = ({ children, variant = 'section' }) => (_jsx(Typography, { variant: getSize(variant), children: children }));
export const RequiredMark = () => (_jsx(Typography, { component: 'span', color: 'error', children: "*" }));
export const BoldLabel = styled((props) => (_jsx(Typography, { component: 'span', ...props })))(() => ({
    fontWeight: 600,
}));
